import { baseClient } from 'src/app/baseClient';
import { Offer } from 'src/features/offers/interfaces/offersInterface';

export async function getOffersByUpsellFlow(flowId: number): Promise<{
  offers: Offer[];
}> {
  const offersEndpoint = `/products/offers`;
  const { data: offers } = await baseClient.get(offersEndpoint, {
    params: { flowId },
  });

  return {
    offers,
  };
}
